// Source/Shadow-Block/Component.ts
class ShadowBlock extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot)
      this.attachTemplate();
  }
  attachTemplate() {
    const { $template } = this;
    if (!$template)
      return;
    const fragment = $template.content;
    const clone = fragment.cloneNode(true);
    const shadow = this.attachShadow({
      mode: "open"
    });
    shadow.append(clone);
  }
  get $template() {
    return this.querySelector(`:scope > template[ shadowrootmode = 'open' ]`);
  }
}

// Source/Shadow-Block/mod.ts
customElements.define("shadow-block", ShadowBlock);
